<div class="panel-pagination-content">
    <div class="panel-pagination-count text-small" [innerText]="getResultsString()"></div>
    <div class="divider-vertical mr-2"></div>
    <div class="panel-pagination-count text-small" [innerText]="getPaginationString()"></div>
    <div class="divider-vertical"></div>
    <div class="panel-action">
        <div class="btn btn-secondary"
             ycnDisabled [disabled]="isFirst()"
             (click)="pageChanged(PAGE_CONTROLS.PREV)">
            <svg ycnIcon [name]="'icon-back'"></svg>
        </div>
    </div>
    <div class="divider-vertical"></div>
    <div class="panel-action">
        <div class="btn btn-secondary"
             ycnDisabled [disabled]="isLast()"
             (click)="pageChanged(PAGE_CONTROLS.NEXT)">
            <svg ycnIcon [name]="'icon-collapse'"></svg>
        </div>
    </div>
</div>
